export const SITE_NAME = "Confideo Cloud & Code";
export const SITE_TAGLINE = "DevOps, AWS, Multi-Cloud Training";
export const DEFAULT_DESCRIPTION =
  "Learn DevOps, AWS, GCP, Azure, and Multi-Cloud with real projects, hands-on training, and career support from Confideo Cloud & Code.";
export const DEFAULT_KEYWORDS =
  "Confideo, DevOps training, AWS course, GCP course, Azure training, Cloud computing, Terraform, Kubernetes, Multi Cloud training, IT courses India";
export const DEFAULT_OG_IMAGE = "/images/c3-logo.png";
export const TWITTER_HANDLE = "@confideocloudcode";

const rawSiteUrl = process.env.REACT_APP_SITE_URL || "https://training.confideoit.com";

export const SITE_URL = rawSiteUrl.replace(/\/$/, "");

export function absoluteUrl(path = "/") {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${normalized}`;
}

export function absoluteImageUrl(imagePath) {
  if (!imagePath) return absoluteUrl(DEFAULT_OG_IMAGE);
  if (imagePath.startsWith("http")) return imagePath;
  return absoluteUrl(imagePath);
}
